import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { getToken } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/pages/index.vue')
  },
  {
    path: '/eco',
    name: 'Eco',
    component: () => import('@/pages/eco.vue')
  },
  {
    path: '/faqs',
    name: 'Faqs',
    component: () => import('@/pages/faqs.vue')

  },
  {
    path: '/hongkong',
    name: 'Hongkong',
    component: () => import('@/pages/hongkong.vue')
  },
  {
    path: '/price',
    name: 'Price',
    component: () => import('@/pages/price.vue')
  },
  {
    path: '/contact-us',
    name: 'ContactUs',
    component: () => import('@/pages/contact-us.vue')
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: () => import('@/pages/article/about-us.vue')
  },
  {
    path: '/copyright',
    name: 'Copyright',
    component: () => import('@/pages/article/copyright.vue')
  },
  {
    path: '/disclaimer',
    name: 'Disclaimer',
    component: () => import('@/pages/article/disclaimer.vue')
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('@/pages/article/privacy-policy.vue')
  },
  {
    path: '/process',
    name: 'Process',
    component: () => import('@/pages/article/process.vue')
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('@/pages/article/terms.vue')
  },
  {
    path: '/article/:id',
    name: 'Article',
    component: () => import('@/pages/article/_id.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/login.vue')
  },
  {
    path: '/login2',
    name: 'Login2',
    component: () => import('@/pages/login2.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/pages/register.vue')
  },
  {
    path: '/holiday',
    name: 'Holiday',
    component: () => import('@/pages/holiday.vue')
  },
  {
    path: '/activation',
    name: 'Activation',
    component: () => import('@/pages/activation.vue')
  },
  {
    path: '/forget',
    name: 'Forget',
    component: () => import('@/pages/forget.vue')
  },

  //////////////需要登录的页面///////////////
  {
    path: '/jiyun',
    name: 'Jiyun',
    component: () => import('@/pages/jiyun.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/order',
    name: 'Order',
    component: () => import('@/pages/order/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/order/declare',
    name: 'OrderDeclare',
    component: () => import('@/pages/order/declare.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/order/declare_oversea',
    name: 'OrderDeclareOversea',
    component: () => import('@/pages/order/declare_oversea.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/order/step2',
    name: 'OrderStep2',
    component: () => import('@/pages/order/step2.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/order/step3',
    name: 'OrderStep3',
    component: () => import('@/pages/order/step3.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/order/payment',
    name: 'OrderPayment',
    component: () => import('@/pages/order/payment.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/order/detail',
    name: 'OrderDetail',
    component: () => import('@/pages/order/detail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/user/account',
    name: 'UserAccount',
    component: () => import('@/pages/user/account.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/user/warehouse',
    name: 'UserWarehouse',
    component: () => import('@/pages/user/warehouse.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/user/address',
    name: 'UserAddress',
    component: () => import('@/pages/user/address.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/user/coupon',
    name: 'UserCoupon',
    component: () => import('@/pages/user/coupon.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/user/exchange',
    name: 'UserExchange',
    component: () => import('@/pages/user/exchange.vue'),
    meta: { requiresAuth: true }
  },
  ///////////////需要登录的页面///////////////
  // 404
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/pages/404.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
import { data } from '@/store/user'
import {
  removeToken
} from '@/utils/auth'

router.beforeEach(async (to, from, next) => {
  const token = getToken()

  if (token) {
    store.commit('user/SET_TOKEN', token)

    if (store.getters.access && !store.getters.hasLogin) {
      try {
        const res = await Vue.prototype.$axios.get('/User/get')
        if (res) await store.dispatch('user/Login', res)
      } catch (e) {
        store.commit('user/SET_TOKEN', data())
        removeToken()
        return next('/login')
      }
    }

    next()
  } else {
    // 没 token，重置整个用户状态
    store.commit('user/SET_TOKEN', data())

    if (to.meta.requiresAuth) {
      next('/login')
    } else {
      next()
    }
  }
})
// 捕获异步组件加载失败，自动刷新页面
router.onError(error => {
  const pattern = /Loading chunk .* failed/i
  const isChunkLoadFailed = pattern.test(error.message)
  if (isChunkLoadFailed) {
    const key = 'chunk_reload'
    const hasReloaded = sessionStorage.getItem(key)
    if (!hasReloaded) {
      sessionStorage.setItem(key, '1')
      window.location.reload()
    } else {
      sessionStorage.removeItem(key)
    }
  }
})

export default router